export const customerConfig = {
  filterTabs: {
    all: {
      label: "All",
      code: "all",
    },
    verified: {
      label: "Verified",
      code: "verified",
    },
    awaitingVerification: {
      label: "Awaiting Verification",
      code: "awaitingVerification",
    },
    awaitingDocuments: {
      label: "Awaiting Documents",
      code: "awaitingDocuments",
    },
    notSubmitted: {
      label: "Not Submitted",
      code: "notSubmitted",
    },
    deactivated: {
      label: "Deactivated",
      code: "deactivated",
    },
  },
};
